(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = '[data-product-description-collapsible]';

    function updateVisibility(root) {
      const content = root.querySelector('[data-product-description-content]');
      const toggle = root.querySelector('[data-product-description-toggle]');

      if (!content || !toggle) return;

      const maxHeight = parseFloat(getComputedStyle(root).getPropertyValue('--product-description-max-height'));
      const hasOverflow = content.scrollHeight > maxHeight + 1;

      if (!hasOverflow) {
        root.classList.remove('is-expanded');
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        return;
      }

      toggle.hidden = false;
    }

    function init(root) {
      if (!root || root.dataset.productDescriptionReady === 'true') return;

      const toggle = root.querySelector('[data-product-description-toggle]');
      const collapsedLabel = root.querySelector('[data-product-description-label-collapsed]');
      const expandedLabel = root.querySelector('[data-product-description-label-expanded]');

      if (!toggle || !collapsedLabel || !expandedLabel) return;

      root.dataset.productDescriptionReady = 'true';

      toggle.addEventListener('click', () => {
        const isExpanded = root.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        collapsedLabel.hidden = isExpanded;
        expandedLabel.hidden = !isExpanded;
      });

      // Check visibility after DOM is fully rendered
      setTimeout(() => updateVisibility(root), 50);
      setTimeout(() => updateVisibility(root), 200);
    }

    function initAll() {
      document.querySelectorAll(rootSelector).forEach(init);
    }

    if (!window.__productDescriptionCollapsibleInit) {
      window.__productDescriptionCollapsibleInit = true;
      window.addEventListener('resize', () => {
        document.querySelectorAll(rootSelector).forEach(updateVisibility);
      });
      document.addEventListener('shopify:section:load', initAll);
    }

    // Initialize on DOMContentLoaded and immediately
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    
    // Also try after a short delay to ensure styles are applied
    setTimeout(initAll, 100);
  })();
  } catch(e) { console.error(e); }
})();

})();
